import React from 'react';
import { CssBaseline } from '@material-ui/core';
import Home from './pages/Home';

function App() {
  return (
    <div className="App">
      <CssBaseline />
      <Home />
    </div>
  );
}

export default App;
